var React = require('react');

function CheckMark (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"opacity":"0.25","cx":"16","cy":"16","r":"16","fill":"#098492","key":0}),React.createElement("path",{"d":"M13.0002 20.1698L8.83016 15.9998L7.41016 17.4098L13.0002 22.9998L25.0002 10.9998L23.5902 9.58984L13.0002 20.1698Z","fill":"#098492","key":1})]);
}

CheckMark.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32","fill":"none"};

module.exports = CheckMark;

CheckMark.default = CheckMark;
